import { IDatasetIntegrationExecution } from '@datasets/dataset-details/datasetHistoryV2/types'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface IProps {
  execution: IDatasetIntegrationExecution
  type: 'success' | 'error'
}

export const IntegrationNotice = ({ execution, type }: IProps) => {
  const outputConfigurationError = execution['Output Configuration Error']

  return (
    <css.Alert key={execution.id} icon={false} type={type}>
      {type === 'error' ? (
        <css.ErrorAlertTitle>{outputConfigurationError}</css.ErrorAlertTitle>
      ) : null}
      {type === 'success' ? (
        <>
          <css.SuccessAlertTitle>{t`Sync successful`}</css.SuccessAlertTitle>
          <css.Divider />
        </>
      ) : null}

      {type === 'success' ? (
        <css.FilePath>
          <strong>{t`Saved file path:`}</strong> {execution['Saved File Path']}
        </css.FilePath>
      ) : null}
    </css.Alert>
  )
}
